import React, { useEffect, useState, useMemo } from "react";
import { Row, Col, Card, CardBody, CardTitle, Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, Spinner, Alert } from "reactstrap";
import InputMask from "react-input-mask";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { pb } from "../../helpers/pocketbase_helper";
import Switch from "react-switch";
import TableContainer from "../../components/Common/DataTableContainer";
import AvatarModal from "../../components/Modals/AvatarModal";

import defaultAvatar from "../../assets/images/users/avatar-6.jpg"; // Usa tu avatar por defecto


const CELULAR_MASK = "3 99 9999999";
const TELEFONO_MASK = "6 99 9999999";

const CelularMask = props => (
    <InputMask
        mask={CELULAR_MASK}
        maskChar=""
        value={props.value}
        className="form-control"
        onChange={props.onChange}
        name={props.name}
        id={props.id}
        required={props.required}
    />
);

const TelefonoMask = props => (
    <InputMask
        mask={TELEFONO_MASK}
        maskChar=""
        value={props.value}
        className="form-control"
        onChange={props.onChange}
        name={props.name}
        id={props.id}
        required={props.required}
    />
);

const Clientes = () => {
    document.title = "Clientes | GraphicForce - Printesco";

    const [clientes, setClientes] = useState([]);
    const [clientesInactivos, setClientesInactivos] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [modalAdd, setModalAdd] = useState(false);
    
    // Estado de paginación
    const [pageIndex, setPageIndex] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [isPagination] = useState(true);
    const [isCustomPageSize] = useState(true);

    const [form, setForm] = useState({ razon_social: "", nit: "", telefono: "", celular: "" });
    const [saving, setSaving] = useState(false);
    const [formActivo, setFormActivo] = useState(true);

    // For delete confirmation
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);
    const [clienteToDelete, setClienteToDelete] = useState(null);
    const [deleting, setDeleting] = useState(false);
    const [maskError, setMaskError] = useState("");
    
    // For restore confirmation
    const [showRestoreAlert, setShowRestoreAlert] = useState(false);
    const [clienteToRestore, setClienteToRestore] = useState(null);
    const [restoring, setRestoring] = useState(false);

    const [avatarFile, setAvatarFile] = useState(null);
    const [deleteError, setDeleteError] = useState("");
    
    // Avatar modal state
    const [avatarModal, setAvatarModal] = useState({ isOpen: false, avatarUrl: '', clienteName: '' });

    const getAvatarUrl = (cliente) => {
        if (cliente.avatar) {
            return `${process.env.REACT_APP_PB_URL}/api/files/cliente/${cliente.id}/${cliente.avatar}`;
        }
        return defaultAvatar;
    };

    // Function to open avatar modal
    const openAvatarModal = (cliente) => {
        setAvatarModal({
            isOpen: true,
            avatarUrl: getAvatarUrl(cliente),
            clienteName: cliente.razon_social
        });
    };

    // Function to close avatar modal
    const closeAvatarModal = () => {
        setAvatarModal({ isOpen: false, avatarUrl: '', clienteName: '' });
    };

    // Manejar cambio de archivo de avatar
    const handleAvatarChange = (e) => {
        const file = e.target.files[0];
        if (file && file.size > 1024 * 1024) { // 1MB = 1024*1024 bytes
            setMaskError("El archivo de avatar debe ser menor a 1MB.");
            // Limpiar el input para que el usuario pueda volver a seleccionar
            e.target.value = "";
            setAvatarFile(null);
            return;
        }
        setAvatarFile(file || null);
    };

    // Limpiar el file input después de guardar
    const resetAvatarInput = () => {
        setAvatarFile(null);
        if (document.getElementById("avatar_input")) {
            document.getElementById("avatar_input").value = "";
        }
    };

    // Fetch todos los clientes y separarlos por estado
    const fetchClientes = async () => {
        try {
            // Obtener todos los clientes de una vez
            const resultList = await pb.collection("cliente").getList(1, 1000, {
                sort: "razon_social"
            });
            
            // Separar clientes activos e inactivos
            const activos = resultList.items.filter(cliente => cliente.activo !== false);
            const inactivos = resultList.items.filter(cliente => cliente.activo === false);
            
            // Aplicar paginación solo a los activos
            const startIndex = pageIndex * pageSize;
            const endIndex = startIndex + pageSize;
            const activosPaginados = activos.slice(startIndex, endIndex);
            
            setClientes(activosPaginados);
            setClientesInactivos(inactivos);
            setTotalRecords(activos.length);
        } catch (err) {
            console.error("Error fetching clientes:", err);
        }
    };

    useEffect(() => {
        fetchClientes();
    }, [pageIndex, pageSize]);

    // Reload clientes only
    const reloadClientes = fetchClientes;

    const handleAdd = () => {
        setForm({ razon_social: "", nit: "", telefono: "", celular: "" });
        setAvatarFile(null);
        setModalAdd(true);
    };




    // Show alert and store cliente to delete
    const handleRemove = (cliente) => {
        setClienteToDelete(cliente);
        setShowDeleteAlert(true);
        // Hacer scroll hacia arriba para mostrar el alert
        setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 100);
    };

    // Confirm delete: set activo to false (soft delete)
    const confirmRemove = async () => {
        if (!clienteToDelete) return;
        setDeleting(true);
        try {
            await pb.collection("cliente").update(clienteToDelete.id, { activo: false });
            fetchClientes();
            setShowDeleteAlert(false);
            setClienteToDelete(null);
            setDeleteError(""); // limpiar error si todo sale bien
        } catch (err) {
            setDeleteError("Error al desactivar cliente");
        }
        setDeleting(false);
    };

    // Cancel delete
    const cancelRemove = () => {
        setShowDeleteAlert(false);
        setClienteToDelete(null);
    };

    // Show alert and store cliente to restore
    const handleRestore = (cliente) => {
        setClienteToRestore(cliente);
        setShowRestoreAlert(true);
        // Hacer scroll hacia arriba para mostrar el alert
        setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 100);
    };

    // Confirm restore: set activo to true
    const confirmRestore = async () => {
        if (!clienteToRestore) return;
        setRestoring(true);
        try {
            await pb.collection("cliente").update(clienteToRestore.id, { activo: true });
            fetchClientes();
            setShowRestoreAlert(false);
            setClienteToRestore(null);
            setDeleteError(""); // limpiar error si todo sale bien
        } catch (err) {
            setDeleteError("Error al restaurar cliente");
        }
        setRestoring(false);
    };

    // Cancel restore
    const cancelRestore = () => {
        setShowRestoreAlert(false);
        setClienteToRestore(null);
    };

    // Handle input changes for both masked and normal inputs
    const handleChange = e => {
        const { name, value } = e.target;
        setForm({
            ...form,
            [name]: name === "razon_social" ? value.toUpperCase() : value
        });
    };

    // Helper to check if mask is fully filled (ignores spaces)
    const isValidMaskedValue = (value, mask) => {
        const digits = (value || "").replace(/\s/g, "");
        return digits.length === 10;
    };

    const cleanNumber = val => (val ? String(val).replace(/\s/g, "") : "");

    const handleSave = async e => {
        e.preventDefault();

        // Validación
        if (form.celular && !isValidMaskedValue(form.celular, CELULAR_MASK)) {
            setMaskError("El número de celular debe tener 10 dígitos.");
            return;
        }
        if (form.telefono && !isValidMaskedValue(form.telefono, TELEFONO_MASK)) {
            setMaskError("El número de teléfono debe tener 10 dígitos.");
            return;
        }

        setMaskError("");
        setSaving(true);
        try {
            const data = {
                razon_social: form.razon_social,
                nit: form.nit,
                telefono: cleanNumber(form.telefono),
                celular: cleanNumber(form.celular),
                activo: true,
            };
            if (avatarFile) {
                data.avatar = avatarFile;
            }
            await pb.collection("cliente").create(data);
            fetchClientes();
            setModalAdd(false);
            resetAvatarInput();
        } catch (err) {
            // Manejo de error de unicidad
            if (
                err?.data?.data?.razon_social &&
                err.data.data.razon_social.code === "validation_not_unique"
            ) {
                setMaskError(
                    `El cliente con el nombre "${form.razon_social}" ya existe, por favor valide la información e intente de nuevo`
                );
            } else {
                setMaskError("Error al agregar cliente");
            }
        }
        setSaving(false);
    };




    // --- Filtering and Pagination ---
    const columns = useMemo(() => [
        {
            header: "Razón Social",
            accessorKey: "razon_social",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Avatar",
            accessorKey: "avatar",
            cell: info => {
                const cliente = info.row.original;
                return (
                    <div className="col-md-6" style={{ maxWidth: 100, display: "flex", justifyContent: "center" }}>
                        <Button
                            color="primary"
                            size="sm"
                            onClick={() => openAvatarModal(cliente)}
                            className="btn-icon"
                            title="Ver avatar"
                        >
                            <i className="fas fa-image"></i>
                        </Button>
                    </div>
                );
            },
            enableColumnFilter: false,
            enableSorting: false,
        },
        {
            header: "Nit",
            accessorKey: "nit",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Teléfono",
            accessorKey: "telefono",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Célular",
            accessorKey: "celular",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Acciones",
            accessorKey: "acciones",
            cell: info => {
                const cliente = info.row.original;
                return (
                    <div style={{ display: "flex", gap: 4, minWidth: 140, maxWidth: 180 }}>
                        <Button color="danger" size="sm" onClick={() => handleRemove(cliente)} disabled={cliente.activo === false}>
                            <i className="fas fa-eraser me-1"></i> Eliminar
                        </Button>
                    </div>
                );
            },
            enableColumnFilter: false,
            enableSorting: false,
            meta: { style: { width: "1%", whiteSpace: "nowrap" } },
        },
    ], [clientes]);

    // Columnas para clientes inactivos
    const columnsInactivos = useMemo(() => [
        {
            header: "Razón Social",
            accessorKey: "razon_social",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Avatar",
            accessorKey: "avatar",
            cell: info => {
                const cliente = info.row.original;
                return (
                    <div className="col-md-6" style={{ maxWidth: 100, display: "flex", justifyContent: "center" }}>
                        <Button
                            color="primary"
                            size="sm"
                            onClick={() => openAvatarModal(cliente)}
                            className="btn-icon"
                            title="Ver avatar"
                        >
                            <i className="fas fa-image"></i>
                        </Button>
                    </div>
                );
            },
            enableColumnFilter: false,
            enableSorting: false,
        },
        {
            header: "Nit",
            accessorKey: "nit",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Teléfono",
            accessorKey: "telefono",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Célular",
            accessorKey: "celular",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Acciones",
            accessorKey: "acciones",
            cell: info => {
                const cliente = info.row.original;
                return (
                    <div style={{ display: "flex", gap: 4, minWidth: 140, maxWidth: 180 }}>
                        <Button color="success" size="sm" onClick={() => handleRestore(cliente)}>
                            <i className="fas fa-undo me-1"></i> Restaurar
                        </Button>
                    </div>
                );
            },
            enableColumnFilter: false,
            enableSorting: false,
            meta: { style: { width: "1%", whiteSpace: "nowrap" } },
        },
    ], [clientesInactivos]);

    // Pagination: only enable if more than 20 clientes


    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs maintitle="Dashboard" title="Administracion" breadcrumbItem="Clientes" />

                    {/* Mask error alert */}
                    {deleteError && (
                        <Alert
                            color="danger"
                            isOpen={!!deleteError}
                            toggle={() => setDeleteError("")}
                            fade={true}
                            transition={{ timeout: 150 }}
                            className="d-flex align-items-center justify-content-between"
                        >
                            <div>
                                <strong>Error:</strong> {deleteError}
                            </div>
                        </Alert>
                    )}

                    {/* Dismissing Alert for Delete */}
                    {showDeleteAlert && clienteToDelete && (
                        <Alert
                            color="warning"
                            isOpen={showDeleteAlert}
                            toggle={cancelRemove}
                            fade={true}
                            transition={{ timeout: 150 }}
                            className="d-flex align-items-center justify-content-between"
                        >
                            <div>
                                <strong>¿Está seguro?</strong> Esto desactivará al cliente <b>{clienteToDelete.razon_social}</b>.
                            </div>
                            <div>
                                <Button color="danger" size="sm" className="me-2" onClick={confirmRemove} disabled={deleting}>
                                    {deleting ? <Spinner size="sm" /> : <i className="fas fa-eraser me-1"></i>} Confirmar
                                </Button>
                                <Button color="secondary" size="sm" onClick={cancelRemove} disabled={deleting}>
                                    Cancelar
                                </Button>
                            </div>
                        </Alert>
                    )}

                    {/* Dismissing Alert for Restore */}
                    {showRestoreAlert && clienteToRestore && (
                        <Alert
                            color="info"
                            isOpen={showRestoreAlert}
                            toggle={cancelRestore}
                            fade={true}
                            transition={{ timeout: 150 }}
                            className="d-flex align-items-center justify-content-between"
                        >
                            <div>
                                <strong>¿Está seguro?</strong> Esto restaurará al cliente <b>{clienteToRestore.razon_social}</b>.
                            </div>
                            <div>
                                <Button color="success" size="sm" className="me-2" onClick={confirmRestore} disabled={restoring}>
                                    {restoring ? <Spinner size="sm" /> : <i className="fas fa-undo me-1"></i>} Confirmar
                                </Button>
                                <Button color="secondary" size="sm" onClick={cancelRestore} disabled={restoring}>
                                    Cancelar
                                </Button>
                            </div>
                        </Alert>
                    )}

                    <Row>
                        <Col>
                            <Card>
                                <CardBody>
                                    <CardTitle className="h4 d-flex justify-content-between align-items-center">
                                        Clientes
                                        <div>
                                            <Button color="primary" size="sm" onClick={handleAdd}>
                                                <i className="fas fa-plus me-1"></i> Agregar
                                            </Button>
                                            <Button
                                                color="secondary"
                                                size="sm"
                                                className="ms-2"
                                                title="Recargar tabla"
                                                onClick={reloadClientes}
                                            >
                                                <i className="fas fa-sync-alt"></i>
                                            </Button>
                                        </div>
                                    </CardTitle>
                                    <div className="table-rep-plugin">
                                        <div className="table-responsive mb-0" data-pattern="priority-columns">
                                            <TableContainer
                                                columns={columns}
                                                data={clientes}
                                                isGlobalFilter={false}
                                                isPagination={true}
                                                isCustomPageSize={true}
                                                pageIndex={pageIndex}
                                                setPageIndex={setPageIndex}
                                                pageSize={pageSize}
                                                setPageSize={setPageSize}
                                                totalRecords={totalRecords}
                                                pagination="pagination"
                                                paginationWrapper='dataTables_paginate paging_simple_numbers'
                                                tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                                            />
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                    {/* Tabla de Clientes Inactivos */}
                    <Row className="mt-4">
                        <Col>
                            <Card>
                                <CardBody>
                                    <CardTitle className="h4 d-flex justify-content-between align-items-center">
                                        Clientes Inactivos
                                        <div>
                                            <Button
                                                color="secondary"
                                                size="sm"
                                                title="Recargar tabla"
                                                onClick={reloadClientes}
                                            >
                                                <i className="fas fa-sync-alt"></i>
                                            </Button>
                                        </div>
                                    </CardTitle>
                                    <div className="table-rep-plugin">
                                        <div className="table-responsive mb-0" data-pattern="priority-columns">
                                            <TableContainer
                                                columns={columnsInactivos}
                                                data={clientesInactivos}
                                                isGlobalFilter={false}
                                                isPagination={false}
                                                isCustomPageSize={false}
                                                tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                                            />
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>

            {/* Modal Agregar */}
            <Modal isOpen={modalAdd} toggle={() => setModalAdd(!modalAdd)} size="lg">
                <ModalHeader toggle={() => setModalAdd(!modalAdd)}>Agregar Cliente</ModalHeader>
                <Form onSubmit={handleSave}>
                    <ModalBody>
                        {maskError && (
                            <Alert
                                color="danger"
                                isOpen={!!maskError}
                                toggle={() => setMaskError("")}
                                fade={true}
                                transition={{ timeout: 150 }}
                                className="d-flex align-items-center justify-content-between mb-3"
                            >
                                <div>
                                    <strong>Error:</strong> {maskError}
                                </div>
                            </Alert>
                        )}
                        <FormGroup>
                            <Label for="razon_social">Razón Social *</Label>
                            <Input
                                type="text"
                                name="razon_social"
                                id="razon_social"
                                value={form.razon_social}
                                onChange={handleChange}
                                required
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for="avatar_input">Avatar</Label>
                            <Input
                                type="file"
                                name="avatar"
                                id="avatar_input"
                                accept="image/*"
                                onChange={handleAvatarChange}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for="nit">Nit</Label>
                            <Input
                                type="text"
                                name="nit"
                                id="nit"
                                value={form.nit}
                                onChange={handleChange}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for="telefono">Teléfono</Label>
                            <TelefonoMask
                                name="telefono"
                                id="telefono"
                                value={form.telefono}
                                onChange={handleChange}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for="celular">Célular</Label>
                            <CelularMask
                                name="celular"
                                id="celular"
                                value={form.celular}
                                onChange={handleChange}
                            />
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => setModalAdd(false)}>
                            Cancelar
                        </Button>
                        <Button color="primary" type="submit" disabled={saving}>
                            {saving ? <Spinner size="sm" className="me-2" /> : null}
                            {saving ? "Guardando..." : "Guardar"}
                        </Button>
                    </ModalFooter>
                </Form>
            </Modal>


            <AvatarModal
                isOpen={avatarModal.isOpen}
                toggle={closeAvatarModal}
                avatarUrl={avatarModal.avatarUrl}
                clienteName={avatarModal.clienteName}
            />
        </React.Fragment>
    );
};

export default Clientes;